import { Injectable } from '@angular/core';
import { USER_TYPE } from '../../../../../../src/app/website/utils/variables.data';
import { AdvisorDTO } from '../models/advisor.dto';
import { AdvisorService } from './advisor.service';
import { TwoFactorType } from '../../../../../../src/app/website/models';

export interface User {
  id: string;
  username: string;
  email: string;
  photo?: any;

  createdDate: string;
  lastLogin: string;

  firstName: string;
  lastName: string;
  fullName: string;

  phone: string;
  phonePrefix: string;
  support2fa: boolean;
  mobile: string;
  mobilePrefix: string;
  mobileVerified: boolean;
  mfaEnabled: boolean;
  twoFactorAuthEnabled: boolean;
  twoFactorNeeded: { type: TwoFactorType };
  lastMobileDigits: string;
  advisor: AdvisorDTO;

  userType: USER_TYPE;
}

@Injectable({ providedIn: 'root' })
export class UserService {
  private _user: User;

  constructor(private advisorService: AdvisorService) {}

  public get user() {
    return this._user;
  }

  public setUser(user?: User) {
    this._user = user;

    if (user?.advisor) {
      this.advisorService.userAdvisor = user.advisor;
    }
  }

  public isAuthenticated() {
    return !!this.user && !!this.user.id && !this.user.twoFactorNeeded;
  }

  public isAuthenticatedNeedsVerify() {
    return !!this.user && !!this.user.twoFactorNeeded;
  }
}
